/* Lightweight seasonal decoration; audio lives in amelie-holiday-audio.js. */
(() => {
  if (window.amelieOctoberReady) return;
  window.amelieOctoberReady = true;
  const flurry = document.querySelector('.am-oct-flurry');
  const observed = new WeakSet();
  const cardObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('is-in-view', entry.isIntersecting));
  }, { threshold: .15 }) : null;
  let motionPaused = false;
  try { motionPaused = sessionStorage.getItem('amelie-oct-motion') === 'off'; } catch (_) {}
  const updateMotion = () => {
    if (flurry) flurry.classList.toggle('is-paused', motionPaused || document.hidden);
    const galleries = document.querySelectorAll('[data-am-oct-cards]');
    galleries.forEach(gallery => {
      gallery.classList.toggle('is-paused', motionPaused || document.hidden);
      if (!observed.has(gallery)) {
        observed.add(gallery);
        if (cardObserver) cardObserver.observe(gallery);
        else gallery.classList.add('is-in-view');
      }
    });
    document.querySelectorAll('[data-am-oct-motion]').forEach(button => {
      button.hidden = !flurry && !galleries.length;
      button.setAttribute('aria-pressed', String(motionPaused));
      button.textContent = motionPaused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
    });
  };
  document.addEventListener('click', event => {
    const motion = event.target.closest('[data-am-oct-motion]');
    if (motion) {
      motionPaused = !motionPaused;
      try { sessionStorage.setItem('amelie-oct-motion', motionPaused ? 'off' : 'on'); } catch (_) {}
      updateMotion();
    }
  });
  document.addEventListener('visibilitychange', updateMotion);
  document.addEventListener('shopify:section:load', updateMotion);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-am-oct-cards]').forEach(gallery => {
      if (cardObserver) cardObserver.unobserve(gallery);
      observed.delete(gallery);
    });
  });
  updateMotion();
})();
